module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/LR-02715fec727beb60f214a4312b34c10e.png";